import isNumber from './is-number';
var isPositive = function (num) {
    return isNumber(num) && num > 0;
};
export default isPositive;
//# sourceMappingURL=is-positive.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/is-positive.js
// module id = 499
// module chunks = 3